import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { isNullOrUndefined, isValidString } from "@pineapplelab/util";
import { BrowserStorage } from "../models/browserStorage";
import  jwt_decode  from "jwt-decode";
import { getAuth } from "@angular/fire/auth";
import { Observable, from, switchMap } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch(Error) {
      return null;
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = BrowserStorage.get('userToken');
    if (!isValidString(token)) {
      return next.handle(req);
    }

    const tokenInfo = this.getDecodedAccessToken(token);

    if (isNullOrUndefined(tokenInfo?.exp)) {
      return next.handle(req);
    }

    const expirationDate = new Date(tokenInfo?.exp * 1000);

    if (expirationDate <= new Date()) {
      if(isNullOrUndefined(getAuth().currentUser)){
        return next.handle(req);
      }
      return from(getAuth().currentUser.getIdToken(true)).pipe(
        switchMap(newToken => {
          token = newToken;
          BrowserStorage.set('userToken', newToken);

          req = req.clone({
            headers: req.headers.set('authorization', token)
          });

          return next.handle(req);
        })
      );
    }

    if (token) {
      req = req.clone({
        headers: req.headers.set('authorization', token)
      });
    }

    return next.handle(req);
  }

}
